/**
 * Created by wangjun on 2019/6/22.
 */
export const server = '';

export const API = {
  'getCategorys' : server+'/data/category.json',
  'getProjectByCId': server+'/data/products.json',
  'getColor': server+'/data/colors.json',
  'getTypes': server+'/data/types.json',
  'getParts':server+'/data/parts.json',
  'getPartsByPId': server+'/data/products_parts.json'
}


export const InitConfig ={
  categoryId: 1,
  productId: 1
}

export function colorHex(str){
  var that = str;
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是rgb颜色表示
  if (/^(rgb|RGB)/.test(that)) {
    var aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
    var strHex = "#";
    for (var i=0; i<aColor.length; i++) {
      var hex = Number(aColor[i]).toString(16);
      if (hex.length < 2) {
        hex = '0' + hex;
      }
      strHex += hex;
    }
    if (strHex.length !== 7) {
      strHex = that;
    }
    return strHex;
  } else if (reg.test(that)) {
    var aNum = that.replace(/#/,"").split("");
    if (aNum.length === 6) {
      return that;
    } else if(aNum.length === 3) {
      var numHex = "#";
      for (var i=0; i<aNum.length; i+=1) {
        numHex += (aNum[i] + aNum[i]);
      }
      return numHex;
    }
  }
  return that;
};

export function isPC() {
  return !!(document.body.clientWidth > 769)
}